import { render, staticRenderFns } from "./UserMessages.vue?vue&type=template&id=60c4ee7a&scoped=true&"
import script from "./UserMessages.vue?vue&type=script&lang=js&"
export * from "./UserMessages.vue?vue&type=script&lang=js&"
import style0 from "./UserMessages.vue?vue&type=style&index=0&id=60c4ee7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c4ee7a",
  null
  
)

export default component.exports